import {
  ColumnPermissions,
  getDefaultColumnPermissions,
  combineColumnPermissions,
  isCorrectColumnPermissions,
  nothingAllowedColumnPermissions
} from './column-permissions'

export interface BoardPermissions {
  editTitle: boolean
  delete: boolean
  move: boolean
  showStickers: boolean
  editStickers: boolean
  addColumn: boolean
  settings: boolean

  columns: ColumnPermissions
}

export const isDisabledBoardProp = (
  obj: BoardPermissions,
  key: keyof BoardPermissions
): boolean => {
  if (key === 'editStickers' && !obj.showStickers) {
    return true
  }
  return false
}

export const getDefaultBoardPermissions = (): BoardPermissions => {
  return {
    editTitle: true,
    delete: true,
    move: true,
    showStickers: true,
    editStickers: true,
    addColumn: true,
    columns: getDefaultColumnPermissions(),
    settings: true
  }
}

export const allowAllOnBoard = (perm: BoardPermissions): BoardPermissions => {
  return {
    ...perm,
    editTitle: true,
    delete: true,
    move: true,
    showStickers: true,
    editStickers: true,
    addColumn: true,
    settings: true
  }
}

export const disallowAllOnBoard = (
  perm: BoardPermissions
): BoardPermissions => {
  return {
    ...perm,
    editTitle: false,
    delete: false,
    move: false,
    showStickers: false,
    editStickers: false,
    addColumn: false,
    settings: false
  }
}

export const nothingAllowedBoardPermissions = (): BoardPermissions => ({
  editTitle: false,
  delete: false,
  move: false,
  showStickers: false,
  editStickers: false,
  addColumn: false,
  columns: nothingAllowedColumnPermissions(),
  settings: false
})

export const isCorrectBoardPermissions = (p: BoardPermissions): boolean => {
  return !!p && isCorrectColumnPermissions(p.columns)
}

export const combineBoardPermissions = (
  a: BoardPermissions,
  b: BoardPermissions
): BoardPermissions => {
  if (!a) {
    return b
  }
  if (!b) {
    return a
  }
  return {
    editTitle: a.editTitle || b.editTitle,
    delete: a.delete || b.delete,
    move: a.move || b.move,
    showStickers: a.showStickers || b.showStickers,
    editStickers: a.editStickers || b.editStickers,
    addColumn: a.addColumn || b.addColumn,
    columns: combineColumnPermissions(a.columns, b.columns),
    settings: a.settings || b.settings
  }
}
